import { jUserLittle, jUserLittleSchema } from './user';
import { Rights, rightsSchema } from './common';
import { z } from 'zod';
import { zSchema } from '../util/zod';
import { jGroupLittleSchema } from './group';
import { jObjectBase, jObjectLittle, jObjectLittleSchema } from './objectBase';

export type jObjectList = jObjectLittle & {
    description?: string | null | undefined;
    _user: jUserLittle;
    _right: Rights;
};
const jObjectListShapeTmp = jObjectLittleSchema.extend({
    description: z.string().optional().nullable(),
    _user: jUserLittleSchema,
    _right: rightsSchema,
});
export const jObjectListSchema = zSchema<jObjectList, typeof jObjectListShapeTmp.shape>(jObjectListShapeTmp);

export const validateIsFormatObjectList = (object: object): object is jObjectList => {
    return jObjectListSchema.safeParse(object).success;
};

export const jFolderLittleSchema = jObjectLittleSchema.extend({
    type: z.enum(['folder', 'rootFolder']),
    folderColor: z.string().optional(),
});
export type jFolderLittle = z.infer<typeof jFolderLittleSchema>;

export const audienceSchema = z.union([jUserLittleSchema, jGroupLittleSchema, jFolderLittleSchema]);
export type Audience = z.infer<typeof audienceSchema>;

export type MaybeWithParent<T extends jObjectBase = jObjectBase> = {
    _parent?: T;
};
